// Hook komentarzy do całej oferty klienta - GET /sales-crm/my-offers/:id/comments

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmMyOfferComment {
  id: number;
  offerVersionId: number | null;
  offerVersionPositionId: number | null;
  comment: string | null;
  fileName: string | null;
  fileUrl: string | null;
  authorType: 'TRADER' | 'CLIENT' | null;
  authorUserId: number | null;
  createdAt: string | null;
}

export interface ISalesCrmMyOfferCommentsResponse {
  items: ISalesCrmMyOfferComment[];
}

export const getSalesCrmMyOfferCommentsQueryKey = (offerId: string | number) =>
  ['sales-crm', 'my-offer', String(offerId), 'comments'] as const;

const getSalesCrmMyOfferComments = (
  offerId: string | number
): Promise<ISalesCrmMyOfferCommentsResponse> =>
  axios.get(`/sales-crm/my-offers/${offerId}/comments`);

export const useGetSalesCrmMyOfferComments = (
  offerId: string | number,
  options?: UseQueryOptions<ISalesCrmMyOfferCommentsResponse, IError>
) =>
  useQuery<ISalesCrmMyOfferCommentsResponse, IError>(
    getSalesCrmMyOfferCommentsQueryKey(offerId),
    () => getSalesCrmMyOfferComments(offerId),
    {
      ...options,
      enabled: options?.enabled !== false && String(offerId).trim().length > 0
    }
  );
